export default {
  signalsNotFound: 'The following signals weren\'t found: {signalNames}',
};
